<template>
  <section id="news" class="ec-section news">
    <div class="ec-container">
      <header class="news__head">
        <div>
          <span class="ec-eyebrow" v-reveal>{{ $t('news.eyebrow') }}</span>
          <h2 class="ec-title" v-reveal="60">{{ $t('news.titlePre') }}<span class="ec-gradient-text">{{ $t('news.titleHi') }}</span></h2>
        </div>
        <a :href="allUrl" target="_blank" rel="noopener" class="ec-btn ec-btn-ghost news__more" v-reveal="80">{{ $t('news.more') }}</a>
      </header>

      <div class="news__grid">
        <a class="ncard ncard--feature" :href="featured.url" target="_blank" rel="noopener" v-reveal>
          <div class="ncard__media" :style="{ background: featured.grad }">
            <span class="ncard__tag">{{ featured.tag }}</span>
            <span class="ncard__emoji">{{ featured.emoji }}</span>
          </div>
          <div class="ncard__body">
            <span class="ncard__date">{{ featured.date }}</span>
            <h3>{{ featured.title }}</h3>
            <p>{{ featured.desc }}</p>
            <span class="ncard__link">{{ $t('news.readMore') }}</span>
          </div>
        </a>

        <div class="news__list">
          <a v-for="(n, i) in items" :key="n.title" class="ncard ncard--row" :href="n.url" target="_blank" rel="noopener" v-reveal="i * 80">
            <div class="ncard__thumb" :style="{ background: n.grad }">{{ n.emoji }}</div>
            <div class="ncard__body">
              <span class="ncard__tag ncard__tag--inline">{{ n.tag }}</span>
              <h4>{{ n.title }}</h4>
              <span class="ncard__date">{{ n.date }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Real AWS news. Visual attrs + real source URLs/dates stay here; titles/tags come from i18n.
const ALL_URL = 'https://aws.amazon.com/new/'
const FEATURED_META = { emoji: '🎤', grad: 'linear-gradient(150deg,#FF9900,#FF6F00)', date: '2025-12-05', url: 'https://reinvent.awsevents.com/' }
const ITEMS_META = [
  { emoji: '🤖', grad: 'linear-gradient(150deg,#FF9900,#FF6F00)', date: '2024-12-03', url: 'https://aws.amazon.com/ai/generative-ai/nova/' },
  { emoji: '🗄️', grad: 'linear-gradient(150deg,#527FFF,#232F3E)', date: '2024-12-03', url: 'https://aws.amazon.com/rds/aurora/dsql/' },
  { emoji: '💻', grad: 'linear-gradient(150deg,#232F3E,#FF9900)', date: '2024-04-30', url: 'https://aws.amazon.com/q/developer/' },
  { emoji: '⚡', grad: 'linear-gradient(150deg,#FF6F00,#FF9900)', date: '2024-07-09', url: 'https://aws.amazon.com/ec2/graviton/' }
]

export default {
  name: 'NewsSection',
  data() {
    return { allUrl: ALL_URL }
  },
  computed: {
    featured() { return { ...FEATURED_META, ...this.$tm('news.featured') } },
    items() { return this.$tm('news.items').map((item, i) => ({ ...ITEMS_META[i], ...item })) }
  }
}
</script>

<style scoped>
.news__head { display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin-bottom: 50px; }
.news__head .ec-title { margin-bottom: 0; }
.news__more { flex: none; }

.news__grid { display: grid; grid-template-columns: 1.05fr 0.95fr; gap: 24px; }

.ncard { background: var(--ec-card); border: 1px solid var(--ec-line); border-radius: 20px; overflow: hidden; transition: transform .3s ease, border-color .3s ease; }
.ncard:hover { transform: translateY(-4px); border-color: rgba(255,153,0,.4); }

.ncard--feature { display: flex; flex-direction: column; }
.ncard__media { position: relative; height: 240px; display: grid; place-items: center; }
.ncard__emoji { font-size: 80px; filter: drop-shadow(0 8px 22px rgba(0,0,0,.35)); }
.ncard__tag { position: absolute; top: 16px; left: 16px; font-size: 12px; font-weight: 700; padding: 5px 12px; border-radius: 999px; background: rgba(4,16,31,.55); color: #fff; backdrop-filter: blur(6px); }
.ncard__tag--inline { position: static; display: inline-block; background: var(--ec-grad-soft); color: var(--ec-cyan); margin-bottom: 8px; }
.ncard__body { padding: 24px; }
.ncard__date { font-size: 13px; color: var(--ec-text-mute); }
.ncard--feature h3 { font-size: 22px; margin: 10px 0 12px; }
.ncard--feature p { font-size: 14.5px; color: var(--ec-text-soft); margin-bottom: 16px; }
.ncard__link { font-size: 14px; font-weight: 600; color: var(--ec-cyan); }

.news__list { display: flex; flex-direction: column; gap: 16px; }
.ncard--row { display: flex; align-items: center; gap: 18px; padding: 16px; }
.ncard__thumb { width: 80px; height: 80px; flex: none; border-radius: 14px; display: grid; place-items: center; font-size: 34px; }
.ncard--row .ncard__body { padding: 0; }
.ncard--row h4 { font-size: 16px; line-height: 1.4; margin: 2px 0 6px; }

@media (max-width: 860px) { .news__grid { grid-template-columns: 1fr; } }
@media (max-width: 480px) { .ncard--row { flex-direction: column; align-items: flex-start; } .ncard__thumb { width: 100%; height: 120px; } }
</style>
